var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegionalOfficeHq01 = function SvgRegionalOfficeHq01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "regional_office_hq-01_svg2__a",
    x1: 42.19,
    x2: 176.03,
    y1: 207.2,
    y2: 55.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__b",
    x1: 46.15,
    x2: 179.98,
    y1: 210.68,
    y2: 58.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__c",
    x1: -3.47,
    x2: 130.37,
    y1: 166.97,
    y2: 15.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__d",
    x1: 11.48,
    x2: 145.31,
    y1: 180.14,
    y2: 28.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__e",
    x1: 7.07,
    x2: 140.9,
    y1: 176.25,
    y2: 24.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__f",
    x1: 22.01,
    x2: 155.85,
    y1: 189.42,
    y2: 37.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__g",
    x1: 17.6,
    x2: 151.44,
    y1: 185.53,
    y2: 33.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__h",
    x1: 32.55,
    x2: 166.38,
    y1: 198.7,
    y2: 46.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__i",
    x1: 28.14,
    x2: 161.97,
    y1: 194.82,
    y2: 42.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__j",
    x1: -6.31,
    x2: 127.52,
    y1: 164.46,
    y2: 12.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__k",
    x1: 4.22,
    x2: 138.06,
    y1: 173.75,
    y2: 21.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__l",
    x1: 43.08,
    x2: 176.92,
    y1: 207.98,
    y2: 56.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__m",
    x1: 56.46,
    x2: 190.3,
    y1: 219.77,
    y2: 67.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__n",
    x1: 67,
    x2: 200.83,
    y1: 229.06,
    y2: 77.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#regional_office_hq-01_svg2__a",
    id: "regional_office_hq-01_svg2__o",
    x1: 77.53,
    x2: 211.37,
    y1: 238.34,
    y2: 86.43
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M137.17 83.18V40.7h-34.09v-9.96c1.49.53 3.23.94 5.02.94 3.85 0 6.69-1.57 9.19-2.96 2.18-1.21 4.06-2.26 6.46-2.26s5.37 1.55 6.27 2.14l4.36 2.91V3.91l-1.25-.83c-.47-.32-4.75-3.08-9.38-3.08-3.85 0-6.69 1.57-9.19 2.96-2.18 1.21-4.06 2.26-6.46 2.26-1.75 0-3.7-.77-5.02-1.43V1.5h-5.61v39.2H62.82v42.48H20.35v63.72h5.31V88.49h37.17v106.2H41.59v-11.03c6.13-1.92 10.62-10.38 10.62-20.83 0-11.91-5.84-21.24-13.27-21.24s-13.28 9.33-13.28 21.24c0 10.45 4.49 18.91 10.62 20.83v11.03H20.35V200h159.3V83.18zm-29.06-72.36c3.85 0 6.69-1.57 9.19-2.96 2.18-1.21 4.06-2.26 6.46-2.26 1.75 0 3.71.77 5.02 1.43V21.8c-1.49-.53-3.23-.94-5.02-.94-3.85 0-6.69 1.57-9.19 2.96-2.18 1.21-4.06 2.26-6.46 2.26-1.75 0-3.71-.77-5.02-1.43V9.88c1.49.53 3.23.94 5.02.94M30.97 162.83c0-9.39 4.2-15.93 7.97-15.93s7.96 6.54 7.96 15.93-4.2 15.93-7.96 15.93-7.97-6.54-7.97-15.93m79.65 31.86H89.38v-31.86h21.24zm21.24 0h-15.93v-37.17H84.07v37.17H68.14V46.01h63.72zm31.16 0h-14.53c-.47-1.73-.7-3.52-.7-5.31 0-7.2 3.65-13.27 7.97-13.27s7.96 6.08 7.96 13.27c0 1.79-.23 3.58-.7 5.31m11.32 0h-5.88c.37-1.74.57-3.53.57-5.31 0-10.42-5.84-18.58-13.27-18.58s-13.28 8.16-13.28 18.58c0 1.78.2 3.57.57 5.31h-5.88V88.49h37.17z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.45 146.9h53.1v5.31h-53.1z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.69 56.63H78.76v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24 56.63h-15.93v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.69 77.87H78.76V93.8h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24 77.87h-15.93V93.8h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.69 99.11H78.76v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24 99.11h-15.93v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.69 120.35H78.76v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.21 99.11H36.28v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.28 136.28h15.93v-15.93H36.28zm5.31-10.62h5.31v5.31h-5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24 120.35h-15.93v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 99.11h-15.93v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 120.35h-15.93v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 141.59h-15.93v15.93h15.93zm-5.31 10.62h-5.31v-5.31h5.31z",
    style: {
      fill: "url(#regional_office_hq-01_svg2__o)"
    }
  }));
};
export default SvgRegionalOfficeHq01;